/**
 * Eine feste Reihenfolge fuer Personen und Familien.
 *
 * Ohne ausdrueckliche Sortierung liefert die Datenbank Zeilen in der
 * Reihenfolge, in der sie gerade greifbar sind - nach einem UPDATE steht
 * ein Kind woanders als vorher. In einer Chronik faellt das sofort auf:
 * Geschwister gehoeren vom aeltesten zum juengsten, und die Familien eines
 * Menschen gehoeren in die Reihenfolge seines Lebens.
 */
/**
 * Aeltestes zuerst.
 *
 * Verglichen wird das ganze Datum, nicht nur das Jahr - zwei Brueder aus
 * demselben Jahr sollen nicht nach Laune nebeneinanderstehen. Wer kein
 * Datum hat, kommt dahinter: ein fehlendes Datum heisst nicht "frueh",
 * sondern "unbekannt", und unten stoert es weniger. Dort entscheidet die
 * Handreihung, zuletzt der Vorname - irgendetwas Festes muss es sein,
 * sonst sieht die Seite bei jedem Laden anders aus.
 */
export function nachGeburt(a, b) {
    const da = a.geburtVon ?? "";
    const db = b.geburtVon ?? "";
    if (da && db && da !== db)
        return da < db ? -1 : 1;
    if (da && !db)
        return -1;
    if (!da && db)
        return 1;
    const ra = a.reihung ?? 0;
    const rb = b.reihung ?? 0;
    if (ra !== rb)
        return ra - rb;
    return (a.vorname ?? "").localeCompare(b.vorname ?? "", "de");
}
/**
 * Datumsschluessel einer Familie, zum Sortieren.
 *
 * Die Hochzeit ist das Datum der Familie. Fehlt sie - was im Altbestand
 * die Regel ist -, tut es das aelteste Kind: eine Familie ist nicht
 * juenger als ihr erstes Kind. Bleibt auch das leer, zaehlt das aelteste
 * Elternteil, damit wenigstens die Generationen stimmen.
 *
 * `null` heisst "nichts bekannt" und landet beim Sortieren hinten.
 */
export function familienDatum(f) {
    if (f.ereignisVon)
        return f.ereignisVon;
    const frueheste = (leute) => {
        const daten = (leute ?? []).map((p) => p.geburtVon).filter((d) => !!d);
        return daten.length ? daten.reduce((a, b) => (a < b ? a : b)) : null;
    };
    return frueheste(f.kinder) ?? frueheste(f.eltern);
}
/** Familien aelteste zuerst; Familien ohne jedes Datum ans Ende. */
export function nachFamilienDatum(a, b) {
    if (a && b && a !== b)
        return a < b ? -1 : 1;
    if (a && !b)
        return -1;
    if (!a && b)
        return 1;
    return 0;
}
//# sourceMappingURL=reihenfolge.js.map